import React, { useState, useEffect, useCallback, useLayoutEffect } from "react";
import { useSelector } from "react-redux";

import { useDataState } from "../../../hooks/useDataState";

import Button from "@mui/material/Button";

import Dialog from "@mui/material/Dialog";

import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";

import {Form, Formik} from "formik";
import http from "../../../shared/http-common";
import DataObjectFormItems from "../Dataobjects/DataobjectFormItems";
import DataobjectService from "../../../services/DataobjectService";
import UploadDialog from "./UploadDialog";
import UploadService from "../../../services/upload-files.service";
import {confirmWrapper} from "../../../shared/confirm";

import {useStylesDialog} from "../../../shared/useStyleDialog";

// Fenster zum Anlegen eines Profils

const initialValues = {
    name: '',
    description: '',
    componenttypes: [],
    guid: '',
    id: null,
    instanceTypeId: null,
    useTypeId: null,
    deactivated: 0
}


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="left" ref={ref} {...props} />;
});

function DataObjectsEdit({dataObjectSelected, handleDeactivateClick, handleActivateClick, reloadObjects}) {
    const classesDialog = useStylesDialog();
    const dataCtx = useDataState();
    const DataobjectsDialogOpen = dataCtx.dialogOpen;
    const setDataobjectsDialogOpen = dataCtx.setDialogOpen;
    const token = useSelector((state) => state.keycloakToken);
    const realm = useSelector((state) => state.theRealm);
    const [instanceTypeId, setInstanceTypeId] = useState(null);
    const [useTypeId, setUseTypeId] = useState(null);
    const [guid, setGuid] = useState("");
    const [id, setId] = useState(null);
    const [formValues, setFormValues] = useState(null);
    const [options, setOptions] = useState([]);
    const [useTypeOptions, setUseTypeOptions] = useState([]);
    const [attributeList, setAttributeList] = useState([]);

    const [message, setMessage] = useState("");
    const [fileInfos, setFileInfos] = useState([]);

    const [uploadDialogOpen, setUploadDialogOpen] = useState(false);

    const [realestateobjectParentValue, setRealestateobjectParentValue] = useState(null);
    const [administrativeobjectParentValue, setAdministrativeobjectParentValue] = useState(null);

    const GetInstanceTypeList = useCallback(async () => {
        try {
            let formData = new FormData();
            formData.append("realm", realm);
            return await http.post(`/lookupTable/getInstanceTypeLookup`, formData,{
                headers: {
                    "Content-Type": "application/json"
                }
            });
        } catch (e) {
            console.error(e);
        }
    }, [realm, token]);

    const GetUseTypeList = useCallback(async () => {
        try {
            let formData = new FormData();
            formData.append("realm", realm);
            return await http.post(`/lookupTable/getUseTypeLookup`, formData,{
                headers: {
                    "Content-Type": "application/json"
                }
            });
        } catch (e) {
            console.error(e);
        }
    }, [realm, token]);

    useEffect(() => {
        if(dataObjectSelected.administrativeobjectTypeGuid) {
            DataobjectService.getAdministrativeobjectTypeAttributes(token, realm, dataObjectSelected.administrativeobjectTypeGuid)
                .then((result) => {
                    setAttributeList(result.data);
                });
            if(dataObjectSelected.parentAdministrativeobjectGuid) {
                const myItem = {};
                myItem.name = dataObjectSelected.parentAdministrativeobjectName;
                myItem.id = dataObjectSelected.parentAdministrativeobjectId;
                myItem.guid = dataObjectSelected.parentAdministrativeobjectGuid;
                myItem.title = dataObjectSelected.parentAdministrativeobjectName;
                myItem.key = dataObjectSelected.parentAdministrativeobjectGuid;
                setAdministrativeobjectParentValue(myItem);
            } else {
                setAdministrativeobjectParentValue(null);
            }
        } else if(dataObjectSelected.realestateobjectTypeGuid) {
            DataobjectService.getRealestateobjectTypeAttributes(token, realm, dataObjectSelected.realestateobjectTypeGuid)
                .then((result) => {
                    setAttributeList(result.data);
                });

            if(dataObjectSelected.parentRealestateobjectGuid) {
                const myItem = {};
                myItem.name = dataObjectSelected.parentRealestateobjectName;
                myItem.id = dataObjectSelected.parentRealestateobjectId;
                myItem.guid = dataObjectSelected.parentRealestateobjectGuid;
                myItem.title = dataObjectSelected.parentRealestateobjectName;
                myItem.key = dataObjectSelected.parentRealestateobjectGuid;
                setRealestateobjectParentValue(myItem);
            } else {
                setRealestateobjectParentValue(null);
            }
        }
    }, [dataObjectSelected, realm, token, setRealestateobjectParentValue]);

    useLayoutEffect(()=>{
        if(dataObjectSelected &&  dataObjectSelected.id) {
            setGuid(dataObjectSelected.guid);
            setId(dataObjectSelected.id);
            setInstanceTypeId(dataObjectSelected.instanceTypeId);
            setUseTypeId(dataObjectSelected.useTypeId);

            const savedValues = {
                name: dataObjectSelected.name,
                number: dataObjectSelected.number,
                label: dataObjectSelected.label,
                description: dataObjectSelected.description,
                guid: dataObjectSelected.guid,
                id: dataObjectSelected.id,
                instanceTypeId: dataObjectSelected.instanceTypeId,
                useTypeId: dataObjectSelected.useTypeId,
                deactivated: dataObjectSelected.deactivated
            }

            if(dataObjectSelected.administrativeobjectAttributeList) {
                dataObjectSelected.administrativeobjectAttributeList.forEach((item) => {
                    savedValues['attr_'+item.attributeTypeGuid] = item.value;
                });
            } else if(dataObjectSelected.realestateobjectAttributeList) {
                dataObjectSelected.realestateobjectAttributeList.forEach((item) => {
                    let myItemValue = item.value
                    attributeList.forEach((attr) => {
                        if(attr.guid === item.attributeTypeGuid) {
                            if(attr.type === 'boolean') {
                                if(item.value === true || item.value === "true" || item.value === 1 || item.value === "1") {
                                    myItemValue = true
                                } else {
                                    myItemValue = false
                                }
                            }
                        }
                    })
                    savedValues['attr_'+item.attributeTypeGuid] = myItemValue;
                });
            }

            setFormValues(savedValues);

            setMessage('');
            async function doSomething() {
                await afterUploadWork();
            }
            doSomething();
        } else {
            setMessage('');
            setFileInfos([]);
            setGuid("");
            setId(null);
            setInstanceTypeId(null);
            setUseTypeId(null);
            const savedValues = {
                name: "",
                number: "",
                label: "",
                description: "",
                guid: "",
                id: null,
                instanceTypeId: null,
                useTypeId: null,
            }
            setFormValues(savedValues);
        }

        if(token && token !== 'Kein Token generiert!') {
            async function loadLookups() {
                const instanceResult = await GetInstanceTypeList();
                if (instanceResult?.data && instanceResult.data.length > 0) {
                    const instanceOptions = instanceResult.data.map(prof => ({value: prof.id, label: prof.label}));
                    setOptions(instanceOptions);
                }
                const useTypeResult = await GetUseTypeList();
                if (useTypeResult?.data && useTypeResult.data.length > 0) {
                    const useTypeOpts = useTypeResult.data.map(prof => ({value: prof.id, label: prof.label}));
                    setUseTypeOptions(useTypeOpts);
                }
            }
            loadLookups();
        }

    }, [dataObjectSelected, realm, token, GetInstanceTypeList, GetUseTypeList]);

    const onChangeInstanceType = (selectedOption) => {
        setInstanceTypeId(selectedOption.value);
    }

    const onChangeUseType = (selectedOption) => {
        setUseTypeId(selectedOption.value);
    }

    const deactivateClick = async(event) => {
        if (await confirmWrapper('Soll das Objekt wirklich deaktiviert werden?')) {
            setDataobjectsDialogOpen(false);
            handleDeactivateClick(dataObjectSelected, event);
        }
    }

    const activateClick = (event) => {
        setDataobjectsDialogOpen(false);
        handleActivateClick(dataObjectSelected, event);
    }

    const saveObject = async (formData, attributeData) => {
        if(dataObjectSelected.administrativeobjectTypeGuid) {
            await DataobjectService.saveAdministrativeobject(token, realm, dataObjectSelected.administrativeobjectTypeGuid, formData, attributeData);
            await reloadObjects();
        } else if(dataObjectSelected.realestateobjectTypeGuid) {
            await DataobjectService.saveRealestateobject(token, realm, dataObjectSelected.realestateobjectTypeGuid, formData, attributeData);
            await reloadObjects();
        }
        setDataobjectsDialogOpen(false);
    }

    const afterUploadWork = async () => {
        let type = dataObjectSelected.administrativeobjectTypeGuid ? 'administrativeobject' : 'realestateobject';
        const files = await UploadService.getFiles(dataObjectSelected.id, token, realm, type);
        setFileInfos(files.data);
    }

    const deleteAttachment = useCallback(async(guid) => {
        if (await confirmWrapper('Soll die Datei wirklich gelöscht werden?')) {
            let type = dataObjectSelected.administrativeobjectTypeGuid ? 'administrativeobject' : 'realestateobject';
            const response = await UploadService.deleteAttachment(guid, token, realm, type);
            if (response.data?.message) {
                setMessage('Die Datei wurde gelöscht.');
            } else if (response.data?.message === 'not found') {
                setMessage('Die Datei wurde nicht gefunden.');
            } else {
                setMessage(response.data.message);
            }
            await afterUploadWork();
        }
    },[token, dataObjectSelected, realm]);

    const downloadFile = async (file) => {
        let formData = new FormData();
        formData.append("realm", realm);
        formData.append("attachmentId", file.id);
        formData.append("filename", file.name);
        let type = dataObjectSelected.administrativeobjectTypeGuid ? 'administrativeobject' : 'realestateobject';
        formData.append("attachmentTable", type);

        const fetchData = await http.post("/attachment/download", formData, {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );
        let fetchDataModified = `data:${file.mime_type};base64,${fetchData.data.base64FileContent}`;
        let a = document.createElement("a");
        a.href = fetchDataModified;
        a.download = file.name;
        a.click();
    }



    return (
        <>
        <Dialog
            className={classesDialog.dialog}
            open={DataobjectsDialogOpen}
            onClose={() => setDataobjectsDialogOpen(false)}
            TransitionComponent={Transition}
            fullScreen
        >
            <Formik
                initialValues={formValues || initialValues}
                enableReinitialize

                onSubmit={async (values, { setSubmitting }) => {
                    const data = {
                        name: values.name,
                        description: values.description,
                        instanceTypeId: instanceTypeId,
                        useTypeId: useTypeId,
                        guid: guid,
                        id: id,
                        label: values.label,
                        number: values.number,
                        deactivated: values.deactivated,
                        parentRealestateobject: realestateobjectParentValue,
                        parentAdministrativeobject: administrativeobjectParentValue,
                    };
                    const objectAttributes = [];
                    Object.entries(values).map(([key, value]) => {
                        if(key.substring(0, 5) === 'attr_') {
                            const arr = key.split('_');
                            const attributeTypeGuid = arr[1];
                            const attr = {};
                            attr.attributeTypeGuid = attributeTypeGuid;
                            attr.value = value;
                            attributeList.map((item) => {
                                if(item.guid === attributeTypeGuid) {
                                    attr.name = item.label;
                                }
                            })
                            objectAttributes.push(attr);
                        }
                    })

                    await saveObject(data, objectAttributes);
                    setSubmitting(false);

                }}

            >
                <Form>

                    <AppBar className={classesDialog.appBar}>
                        <Toolbar>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={() => setDataobjectsDialogOpen(false)}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" className={classesDialog.title}>
                                {dataObjectSelected?.id ? `Objekt bearbeiten`: `Objekt hinzufügen`}
                            </Typography>
                                <Button
                                    type="submit"
                                    color="inherit"
                                >
                                    Speichern
                                </Button>
                        </Toolbar>
                    </AppBar>

                    <DataObjectFormItems
                        dataObjectSelected={dataObjectSelected}
                        options={options}
                        attributeList={attributeList}
                        instanceTypeId={instanceTypeId}
                        onChangeInstanceType={onChangeInstanceType}
                        realestateobjectParentValue={realestateobjectParentValue}
                        setRealestateobjectParentValue={setRealestateobjectParentValue}
                        administrativeobjectParentValue={administrativeobjectParentValue}
                        setAdministrativeobjectParentValue={setAdministrativeobjectParentValue}
                        useTypeOptions={useTypeOptions}
                        useTypeId={useTypeId}
                        onChangeUseType={onChangeUseType}
                        />
                    <Toolbar>
                        {dataObjectSelected?.deactivated ? (
                            <Button onClick={(event) => activateClick(event)} color="inherit" variant="outlined" size="medium">Aktivieren</Button>
                        ) : null}
                        {dataObjectSelected && !dataObjectSelected.deactivated ? (
                            <Button onClick={(event) => deactivateClick(event)} color="inherit" variant="outlined" size="medium">Deaktivieren</Button>
                        ) : null}
                        <Button
                            variant="outlined"
                            onClick={()=>setUploadDialogOpen(true)}
                            color="inherit"
                            size="medium"
                        >Upload</Button>
                    </Toolbar>
                    {fileInfos.length > 0 ? (
                        <div className="card">
                            <div className="card-header">Liste der Dateien auf m Server</div>
                            <ul className="list-group list-group-flush">
                                {fileInfos &&
                                    fileInfos.map((file, index) => (
                                        <li className="list-group-item" key={index}>
                                            <img src={`data:${file.mime_type};base64,${file.previewBase64content}`} alt=""/>
                                            <div>{file.name}</div>
                                            <Button onClick={()=>downloadFile(file)}>Download</Button>
                                            <Button onClick={()=>deleteAttachment(file.guid)}>Löschen</Button>
                                        </li>
                                    ))}
                            </ul>
                        </div>
                    ) : null }
                    <div className="alert alert-light" role="alert">
                        {message}
                    </div>

                </Form>
            </Formik>
        </Dialog>
        <UploadDialog
            dataObjectSelected={dataObjectSelected}
            setUploadDialogOpen={setUploadDialogOpen}
            uploadDialogOpen={uploadDialogOpen}
            callbackFunc={afterUploadWork}
        />

        </>
    );
}

export default DataObjectsEdit;
